<template>
  <div
    class="loader-container"
    :class="{
      ['loader-container_loading']: isLoading,
      ['loader-container_fetching']: isFetching,
    }"
  >
    <div class="loader">Пожалуйста, подождите...</div>
  </div>
</template>

<script>
export default {
  props: ['isLoading', 'isFetching'],
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.loader-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: $bgColor;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 10;

  &_loading {
    display: flex;
  }

  &_fetching {
    display: flex;
    opacity: 0.9;
  }
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(0, 102, 179, 0.2);
  border-right: 1.1em solid rgba(0, 102, 179, 0.2);
  border-bottom: 1.1em solid rgba(0, 102, 179, 0.2);
  border-left: 1.1em solid rgba(0, 102, 179, 1);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
